<template>
  <div class="main_center">
    <div class="content" style="position: relative">

      <!--Video-->
      <div class="streamPlayerWrapper" :style="{height:videoHeight + 'px'}">
        <streamPlayer
                ref="streamPlayerRef"
                videoCode="flv"
                :height="videoHeight.toString()"
                :videoUrl.sync="videoUrl">
        </streamPlayer>
        <placeAndEquipment
                ref="placeAndEquipmentRef"
                roomType="4"
                :showSrcSwitch="true"
                :currentVideo.sync="currentVideo"
                :videoSwitchData.sync="videoSrcData"
                @switchCurrentVideo="switchVideoUrl">
        </placeAndEquipment>
        <div class="inoutWrapper">
          <iframe
                  v-if="isIE"
                  style="position:absolute;z-index:-1;width:100%;height:100%;top:0;left:0;right:0;bottom:0"
                  allowtransparency="true"
                  src=""
                  frameborder="0"></iframe>
          <div v-if="personList.length > 0">
            <div class="arrow" @click="prePage"> <i class="el-icon-arrow-up"></i> </div>
            <div class="personInfo" v-for="(item,index) in personList" :key="index">
<!--              <img @click="showImgDialog(item.url)" :src="require('@/assets/images/load_error.png')" v-real-img="item.url ||(item.attachments && item.attachments[0] && item.attachments[0].filePath) ">-->
                        <img :src="require('@/assets/images/load_error.png')" v-real-img="item.attachments && item.attachments[0] && item.attachments[0].filePath">
              <span :class="formatterClass(item)" >【{{ item.inoutFlagName }}】</span>
              <span class="personName" >{{ item.personName }} | {{ item.personRoleName }}</span>
              <p><span >{{item.createTime}}</span></p>
            </div>
            <div class="arrow" @click="nextPage"> <i class="el-icon-arrow-down"></i> </div>
          </div>
        </div>
      </div>

<!--      <div style="width: 100px;position: absolute;right: 16px;top:16px">-->
<!--        <el-table-->
<!--                :data="guardListData"-->
<!--                border>-->
<!--          <el-table-column-->
<!--                  v-for="info in guardHeader" :key="info.key"-->
<!--                  :property="info.key"-->
<!--                  :label="info.label"-->
<!--                  :show-overflow-tooltip='true'>-->
<!--            <template slot-scope="scope">-->
<!--              <span @click="getByGuardid(scope.row)"> {{ scope.row[scope.column.property] }} </span> &lt;!&ndash; 渲染对应表格里面的内容 &ndash;&gt;-->
<!--            </template>-->
<!--          </el-table-column>-->
<!--        </el-table>-->
<!--      </div>-->
<!--      <el-pagination-->
<!--              @size-change="sizeChangeHandle"-->
<!--              @current-change="currentChangeHandle"-->
<!--              :current-page="pageIndex"-->
<!--              :page-size="pageSize"-->
<!--              :total="total"-->
<!--              layout="sizes, prev, pager, next">-->
<!--      </el-pagination>-->

    </div>
    <el-dialog :visible.sync="imgDialogVisible" width="100%" height="100%" @opened="dialogOpen">
      <img :src="dialogImageUrl" alt="" @contextmenu.prevent=""  class="viewImg">
    </el-dialog>
  </div>


</template>

<script>
    import {mapState} from "vuex";
    import streamPlayer from "@/components/videoPlayer/streamPlayer";
    import placeAndEquipment from "@/components/videoPlayer/placeAndEquipment";
    import {isIEBrowser} from '@/utils/index';

    export default {
  components: {
    streamPlayer,
    placeAndEquipment
  },
  data() {
    return {
      dialogImageUrl:"",
      videoHeight:750,
      imgDialogVisible:false,
      currentVideo:{},
      videoSrcData:[],
      videoUrl:'',
      isIE:false,
      personRoleList: [],
      inoutFlagList: [],
      datetimerange: [],
      guardListData: [],
      moreSearchItem: false,
      checkList1: '',
      pageSize: 5,//每页条数
      pageIndex: 1,//当前页
      total: 0,//总条数
      tableData: [],
      multipleSelection: [],
      user: '', //角色类型
      formData: {},
      personList: [],
      guardHeader: [
        {
          label: '发生门禁',
          key: 'name',
        },

      ],

    }
  },
  computed: {
    ...mapState({
      stateData: state => state.user
    }),
  },
  filters: {
    ellipsis(text, num) {
      if (text.length > num) {
        return text.substring(0, num) + '...';
      } else {
        return text;
      }
    },
  },
  activated() {
    // // 获取门禁摄像头地址
    // this.getGuardList();


    this.$nextTick(() => {
      if(this.$refs.streamPlayerRef){
        this.$refs.streamPlayerRef.play(); // 播放
      }
    })


  },
  deactivated() {
    if(this.$refs.streamPlayerRef){
      this.$refs.streamPlayerRef.pause();  // 暂停
    }
  },
  created() {
    this.isIE = isIEBrowser();
  },
  mounted() {

    // 获取门禁摄像头地址
    this.getGuardList();
    this.videoHeight = document.documentElement.clientHeight<600?600:(document.documentElement.clientHeight-144);

  },
  methods: {


    formatterClass(item){
      switch(item.inoutFlag){
        case 1: return 'inoutflag green'; break;
        case 2: return 'inoutflag blue'; break;
        case 3 : return 'inoutflag danger'; break;
        default:return 'inoutflag';break;
      }
    },

    // 图片放大弹窗
    showImgDialog(filePath){
      this.dialogImageUrl=filePath;
      this.imgDialogVisible = true;
      this.$nextTick(()=>{
        this.iframeInsert(this.$el);
      })
    },

    dialogOpen(){
      this.$nextTick(() => {
        this.iframeInsert(this.$el);
      });
    },


    switchVideoUrl(video){

      this.currentVideo = video;
      this.videoUrl = this.currentVideo.playUrl?this.currentVideo.playUrl:"";
      this.getDataList();
    },




    getGuardList() {//门禁下拉框


      this.$http.post('/sysGuardConfig/list', {
        'page': this.pageIndex,
        'rows': this.pageSize,
      }).then(res => {
        this.guardListData = res.data.rows;
        this.guardListData.forEach((item)=>{
          item.playUrl = item.streamUrl;
          item.deviceType = 2;
          item.deviceName = item.name;
        })
        this.total = res.data.total;

        if(this.guardListData.length > 0){
          var obj = {
            fieldInfo:{fieldName:'实时门禁',regionName:"咸宁"},
            devices:this.guardListData || []
          }
          this.videoSrcData = [obj];

            const videoObj = JSON.parse(JSON.stringify(this.guardListData[0]));
            videoObj.playUrl = videoObj.playUrl?videoObj.playUrl:"";
            videoObj.leavel = videoObj.deviceName?videoObj.deviceName:"";
            this.currentVideo=videoObj;
            this.$refs.placeAndEquipmentRef.setCurrentVideo(this.currentVideo);
            this.videoUrl = this.currentVideo.playUrl?this.currentVideo.playUrl:"";

            this.getDataList();

        }else{
          this.videoSrcData = [];
        }



        // if(this.videoSrcData[0] && this.videoSrcData[0].devices && this.videoSrcData[0].devices[0]){
        //   const videoObj = JSON.parse(JSON.stringify(this.videoSrcData[0].devices[0]));
        //   videoObj.playUrl = videoObj.playUrl?videoObj.playUrl:"";
        //   videoObj.leavel = videoObj.deviceName?videoObj.deviceName:"";
        //   this.currentVideo=videoObj;
        //   this.$refs.placeAndEquipmentRef.setCurrentVideo(this.currentVideo);
        //   this.getKeyIframeList()
        // }
        // this.videoSrcData = res.data.data;
        // this.videoUrl = this.currentVideo.playUrl?this.currentVideo.playUrl:"";

      })

    },


    getDataList() { // 获取列表数据
      var guardId = this.currentVideo.id || '';

      this.$http.post('/guardWitness/list', {
        'page': this.pageIndex,
        'rows': this.pageSize,
        'filter':{
          guardId: guardId, //门禁id
        }
      }).then(res => {
        this.personList = res.data.rows;
        this.total = res.data.total;
      })


        // this.personList = [
        //     {
        //         inoutFlagName:"",
        //         personName:"",
        //         personRoleName:"",
        //         createTime:"",
        //         url:"/public/20210804/dgwitness/b37230bf5e2b46b4b0bfc5b3da74020e/blob"
        //     },
        //     {
        //         inoutFlagName:"",
        //         personName:"",
        //         personRoleName:"",
        //         createTime:"",
        //         url:"/public/20210804/dgwitness/8b8680f1e6594818a5f0d1304e4a1fe7/blob"
        //     }]

    },


    getByGuardid(item){

      this.$http.post('/guardWitness/list', {
        'page': this.pageIndex,
        'rows': this.pageSize,
        'filter':
            {
              guardId: item.id, //门禁id
            }
      }).then(res => {
        this.list = res.data.rows;
        this.total = res.data.total;
      })
    },


    indexMethod(index) {
      return (this.pageIndex - 1) * this.pageSize + index + 1
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },


    prePage(){

      if(this.pageIndex >1){
        this.pageIndex--;
        this.getDataList()
      }else{
        this.$message({
          type:'error',
          message:'已到顶部'
        })
      }


    },
    nextPage(){
      var maxPage = Math.round(this.total/this.pageSize )

      if(this.pageIndex ==1){
        this.pageIndex--;
        this.getDataList()
      }else{
        this.$message({
          type:'error',
          message:'已到顶部'
        })
      }


    },

    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1
      this.getDataList()
    },

    currentChangeHandle(val) {
      this.pageIndex = val
      this.getDataList()
    },


  }


}
</script>

<style lang="less" scoped>





.main_center {

  .content{

    .streamPlayerWrapper{
      width: 100%;height:750px;
      display: block;
      text-align: center;
      position: relative;
      z-index: 500;

      .inoutWrapper{
        position: absolute;
        margin: 20px 10px;
        left: 16px;
        top:16px;
        z-index: 600;
        .arrow{
          border: 1px solid #1965FF;
          cursor: pointer;
          color:#FFFFFF;
          box-shadow:0px 0px 6px #1965FF inset;
          line-height: 20px;
          text-align:center;
          border-radius: 2px;
          &:first-child{
            margin-bottom: 10px;
          }
        }



        .personInfo{
          position: relative;
          color:#FFFFFF;
          padding: 8px;
          margin-bottom: 10px;
          border: 1px solid #1965FF;
          color:#FFFFFF;
          box-shadow:0px 0px 6px #1965FF inset;
          position: relative;
          img{
            background-color: #f8faff;
            margin-bottom: 36px;
            height: 100px;
          }
          .inoutflag{
            position: absolute; top:12px; right:4px;
          }
          span.green{
            color: green;
          }
          span.blue{
            color: #1965FF;
          }
          span.danger{
            color: red;
          }
          span.personName{
            position: absolute; bottom:20px; left:8px;font-size: 16px;
          }
          p{
            position: absolute;
            bottom:4px;
            left: 8px;
            margin: 0;
          }
          img{
            width: 150px;
          }

        }

      }

    }

  }

}

.margin-hide {
  .el-form-item__content {
    margin-left: 0 !important;
  }
}


</style>